import React, { Component } from "react"
import styled from "@emotion/styled"
import { colors } from "../constants"

export default styled.span(
  {
    fontFamily: "Avenir Next",
    color: colors.brand,
    fontWeight: "bold",
  },
  props => ({
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
  })
)
